export default __webpack_public_path__ + "static/media/snapchat-logo-transparent-white.de1b3771.png";